import { render } from "./Navbar.vue?vue&type=template&id=3591942e&scoped=true"
import script from "./Navbar.vue?vue&type=script&lang=js"
export * from "./Navbar.vue?vue&type=script&lang=js"

import "./Navbar.vue?vue&type=style&index=0&id=3591942e&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-3591942e"

export default script